import {
  OTHER_PREFIX_VALUE,
  PREFER_NOT_TO_SAY_VALUE,
} from "constants/prefixes";

const normalize = (s: string) =>
  (s || "").replace(/\./g, "").trim().toLowerCase();

export const findKnownOptionValue = (
  value: string,
  options: Array<{ value: string }>
): string | null => {
  const target = normalize(value);
  const match = options.find((opt) => normalize(opt.value) === target);
  return match ? match.value : null;
};

export const getUIPrefix = (
  sourceValue: string | undefined,
  options: Array<{ value: string }>
): { selected: string; custom: string } => {
  const value = sourceValue ?? "";
  if (value === "" || value === PREFER_NOT_TO_SAY_VALUE) {
    return { selected: "", custom: "" };
  }
  const selectedValue = findKnownOptionValue(value, options);
  if (selectedValue) return { selected: selectedValue, custom: "" };
  return { selected: OTHER_PREFIX_VALUE, custom: value };
};
